const schema = [
  { width: 100, field: 'eventType', displayName: 'Event Type', type: 'string' },
  { width: 135, field: 'eventSubtype', displayName: 'Event Sub Type', type: 'string' },
  { width: 170, field: 'eventDate', displayName: 'Event Date', type: 'datetime' },
  { width: 150, field: 'user', displayName: 'User', type: 'string' },
  { width: 110, field: 'status', displayName: 'Status', type: 'string' },
  { width: 200, field: 'subStage', displayName: 'Sub-Stage', type: 'string' },
  { width: 400, field: 'details', displayName: 'Details', type: 'string' }
];

export default schema;